export const userRoleEnum = {
  UNDERWRITER: 'underwriter',
  AGENT: 'agent',
  UNDERWRITING_ADMIN: 'underwriting_admin',
  SYSTEM_ADMIN: 'system_admin',
} as const;

// eslint-disable-next-line @typescript-eslint/naming-convention
export type userRole =
  | 'underwriter'
  | 'agent'
  | 'underwriting_admin'
  | 'system_admin';

export const permissionGroupEnum = {
  AGENT: 'AGENT',
  UNDERWRITER: 'UNDERWRITER',
  UNDERWRITING_ADMIN: 'UNDERWRITING_ADMIN',
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
} as const;

export type PermissionGroup =
  (typeof permissionGroupEnum)[keyof typeof permissionGroupEnum];
